import FarmShareBG from '../../assets/FarmshareBG.jpg';
import { Navbar } from '../../components/Navbar';

import { useSelector, useDispatch } from 'react-redux';
import {
  getAllEquipment,
  updateEquipment,
  clearError,
} from '../../redux/slices/equipmentsSlice';
import { useEffect, useState } from 'react';
import { EquipmentTable } from '../../components/EquipmentTable';

import { EquipmentContentModal } from '../../components/EquipmentContentModal';

import { DeleteEquipmentModal } from '../../components/DeleteEquipmentModal';
import { AddEquipmentModal } from '../../components/AddEquipmentModal';
import { LoadingModal } from '../../components/LoadingModal';
import { UpdateEquipmentModal } from '../../components/UpdateEquipmentModal';

const EquipmentListPage = () => {
  const dispatch = useDispatch();
  const equipments = useSelector((state) => state.equipments.equipments);
  const loading = useSelector((state) => state.equipments.loading);
  const error_message = useSelector((state) => state.equipments.error);
  const [updateEquipmentModal, setUpdateEquipmentModal] = useState(false);
  const [deleteEquipmentModal, setDeleteEquipmentModal] = useState(false);
  const [addEquipmentModal, setAddEquipmentModal] = useState(false);
  const [viewContentModal, setViewContentModal] = useState(false);
  const [viewEquipment, setViewEquipment] = useState(null);

  useEffect(() => {
    dispatch(getAllEquipment());
  }, [dispatch]);

  const handleUpdate = (e) => {
    e.preventDefault();
    dispatch(updateEquipment(viewEquipment._id));
    setUpdateEquipmentModal(false);
    setViewEquipment(null);
  };

  const handleDismissError = () => {
    dispatch(clearError());
  };

  return (
    <div className="bg-sky-200">
      <Navbar src={FarmShareBG} pageName={`Equipment List`} pageText={''} />
      {/* {updateEquipmentModal && (
        <UpdateEquipmentModal
          setUpdateModal={setUpdateEquipmentModal}
          setViewEquipment={setViewEquipment}
          handleUpdate={handleUpdate}
          viewEquipment={viewEquipment}
        />
      )} */}

      {updateEquipmentModal && (
        <UpdateEquipmentModal
          handleUpdate={handleUpdate}
          setUpdateModal={setUpdateEquipmentModal}
          viewEquipment={viewEquipment}
        />
      )}

      {addEquipmentModal && (
        <AddEquipmentModal setAddEquipmentModal={setAddEquipmentModal} />
      )}

      {deleteEquipmentModal && (
        <DeleteEquipmentModal
          setDeleteModal={setDeleteEquipmentModal}
          setViewEquipment={setViewEquipment}
          viewEquipment={viewEquipment}
        />
      )}
      {viewContentModal && (
        <EquipmentContentModal
          setViewContentModal={setViewContentModal}
          viewEquipment={viewEquipment}
        />
      )}
      {(loading || error_message) &&
        !deleteEquipmentModal &&
        !updateEquipmentModal &&
        !addEquipmentModal &&
        !viewContentModal && (
          <LoadingModal
            message="Loading equipment..."
            error={error_message}
            onClose={error_message ? handleDismissError : null}
          />
        )}
      {
        <EquipmentTable
          equipments={equipments}
          setDeleteModal={setDeleteEquipmentModal}
          setUpdateModal={setUpdateEquipmentModal}
          setViewContentModal={setViewContentModal}
          loading={loading}
          setViewEquipment={setViewEquipment}
          setAddEquipmentModal={setAddEquipmentModal}
        />
      }
    </div>
  );
};

export { EquipmentListPage };
